import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import NamedLink from '../NamedLink/NamedLink';

import css from './AddressDisplayCard.module.css';

/**
 * Read-only summary of a saved address — shown in places (Frakt tab,
 * CheckoutPage) where the user already has a default on their profile
 * and we don't want to re-render the full address subform. Edits route
 * users to ContactDetailsPage where their defaults live, so there's
 * one canonical edit surface.
 *
 * Props:
 *   - address: { name, addressLine, addressLine2?, postalCode, city }
 *   - phoneNumber: optional phone string to display alongside the address;
 *     used on CheckoutPage so the saved phone is visible without a
 *     separate input, while edits still route to ContactDetailsPage.
 *   - editLinkRouteName: NamedLink route to send users to for edits
 *     (defaults to ContactDetailsPage).
 *   - labelMessageId: translation key for the section label
 *     ("Avsenderadresse" / "Leveringsadresse").
 */
const AddressDisplayCard = props => {
  const {
    address,
    phoneNumber,
    editLinkRouteName = 'ContactDetailsPage',
    labelMessageId,
    className,
    rootClassName,
  } = props;

  if (!address || !address.addressLine || !address.postalCode) {
    return null;
  }

  return (
    <div className={classNames(rootClassName || css.root, className)}>
      <div className={css.body}>
        {labelMessageId ? (
          <p className={css.label}>
            <FormattedMessage id={labelMessageId} />
          </p>
        ) : null}
        <p className={css.line}>{address.name}</p>
        {phoneNumber ? <p className={css.line}>{phoneNumber}</p> : null}
        <p className={css.line}>{address.addressLine}</p>
        {address.addressLine2 ? <p className={css.line}>{address.addressLine2}</p> : null}
        <p className={css.line}>
          {address.postalCode} {address.city}
        </p>
      </div>
      <NamedLink name={editLinkRouteName} className={css.editLink}>
        <FormattedMessage id="AddressDisplayCard.editLink" />
      </NamedLink>
    </div>
  );
};

export default AddressDisplayCard;
